import React from "react";

import TenantReportCardListForPersonal from "./TenantReportCardListForPersonal";
import TenantReportsTableForPersonal from "./TenantReportsTableForPersonal";

interface TenantReportsWithQueryProps {
  isMd: boolean;
  searchFilter: string;
  additionalFilters: {
    is_active?: string;
    status?: string;
    legal_type?: string;
  };
}

const TenantReportsWithQuery: React.FC<TenantReportsWithQueryProps> = ({
  isMd,
  searchFilter,
  additionalFilters,
}) => {
  const commonProps = {
    showAdvisorColumn: false,
    searchFilter,
    additionalFilters,
  };

  return isMd ? (
    <TenantReportsTableForPersonal {...commonProps} />
  ) : (
    <TenantReportCardListForPersonal {...commonProps} />
  );
};

export default TenantReportsWithQuery;
